// Export validation function for use in other components
export const validatePasswordRequirements = password => {
  if (!password) return false

  return (
    password.length >= 12 &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /[0-9]/.test(password) &&
    /[^A-Za-z0-9]/.test(password)
  )
}
